/** Redirect to the home path if the current route does not match it. */
export default defineNuxtRouteMiddleware((to) => {
  const { homePath } = useHome();

  if (to.path !== homePath.value) {
    // TODO CVO-19899 [Redirect] Remove { external: true } once booking flow in released in Veloair
    return navigateTo(homePath.value as string, { external: true });
  }
});
